import React from 'react';
import { Link } from 'react-scroll';

import './ScrollSection.scss';

const ScrollSection = props => (
  <div className={'scroll-section-container'}>
    <Link to="homepage-player"
          smooth={true}
          duration={500}
          spy={true}
          className={`scroll-section__item ${props.elementsActive ? 'scroll-section__item--active' : ''}`}>
      ELEMENTS
    </Link>
    <Link
      to="homepage-highlights"
      smooth={true}
      duration={500}
      spy={true}
      className={`scroll-section__item ${props.playspaceActive ? 'scroll-section__item--active' : ''}`}>
      PLAYSPACE
    </Link>
  </div>
);

export default ScrollSection;